import React from 'react';
import { Tag } from 'antd';
import styled from '@emotion/styled';
import { toSubscriptionPlan } from '../../../../utils/transfer/access-code';
import { appStyles } from '../../../../styles';

interface SubscriptionPlanColumnProps {
  value: number;
}

export default React.memo((props: SubscriptionPlanColumnProps) => {
  return (
    <StyledContainer>
      <Tag color="#EEEEEE" className="default">
        {toSubscriptionPlan(props.value)}
      </Tag>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  .ant-tag {
    width: 120px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    border-radius: 0;
    font-size: 14px;
    &.default {
      ${appStyles.color.black}
    }
  }
`;
